module.exports = __webpack_public_path__ + "static/media/imgslider1.6d61c1a0.jpg";